"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/step-user-group.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fstep-user-group.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.stepUserGroupToJSON = exports.stepUserGroupFromJSON = exports.StepUserGroup = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.proto';
/**
 * Step user groups. A user can belong to multiple groups.
 */
var StepUserGroup;
(function (StepUserGroup) {
    StepUserGroup["INVALID_STEP_USER_GROUP"] = "INVALID_STEP_USER_GROUP";
    StepUserGroup["AML"] = "AML";
    StepUserGroup["BATCH_FUNDING_ADMIN"] = "BATCH_FUNDING_ADMIN";
    StepUserGroup["COMPLIANCE"] = "COMPLIANCE";
    StepUserGroup["COMPLIANCE_MANAGERS"] = "COMPLIANCE_MANAGERS";
    StepUserGroup["CX"] = "CX";
    StepUserGroup["CX_MANAGERS"] = "CX_MANAGERS";
    StepUserGroup["CX_QA"] = "CX_QA";
    StepUserGroup["DATA"] = "DATA";
    StepUserGroup["DATA_MANAGER"] = "DATA_MANAGER";
    StepUserGroup["DESIGN"] = "DESIGN";
    StepUserGroup["ENGINEERING"] = "ENGINEERING";
    StepUserGroup["ENGINEERING_MANAGERS"] = "ENGINEERING_MANAGERS";
    StepUserGroup["FINANCE"] = "FINANCE";
    StepUserGroup["FRAUD"] = "FRAUD";
    StepUserGroup["GROWTH"] = "GROWTH";
    StepUserGroup["GROWTH_MANAGERS"] = "GROWTH_MANAGERS";
    StepUserGroup["KYC_REVIEW"] = "KYC_REVIEW";
    StepUserGroup["LEGAL"] = "LEGAL";
    StepUserGroup["PRODUCT"] = "PRODUCT";
    StepUserGroup["PRODUCT_MANAGERS"] = "PRODUCT_MANAGERS";
    StepUserGroup["RECRUITING"] = "RECRUITING";
    StepUserGroup["RESEARCH"] = "RESEARCH";
    StepUserGroup["RISK_MANAGERS"] = "RISK_MANAGERS";
    StepUserGroup["TRUST_SAFETY"] = "TRUST_SAFETY";
    StepUserGroup["UBIQUITY"] = "UBIQUITY";
    StepUserGroup["SUPER_USERS"] = "SUPER_USERS";
    StepUserGroup["UNRECOGNIZED"] = "UNRECOGNIZED";
})(StepUserGroup || (exports.StepUserGroup = StepUserGroup = {}));
function stepUserGroupFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_STEP_USER_GROUP':
            return StepUserGroup.INVALID_STEP_USER_GROUP;
        case 13:
        case 'AML':
            return StepUserGroup.AML;
        case 27:
        case 'BATCH_FUNDING_ADMIN':
            return StepUserGroup.BATCH_FUNDING_ADMIN;
        case 5:
        case 'COMPLIANCE':
            return StepUserGroup.COMPLIANCE;
        case 30:
        case 'COMPLIANCE_MANAGERS':
            return StepUserGroup.COMPLIANCE_MANAGERS;
        case 11:
        case 'CX':
            return StepUserGroup.CX;
        case 12:
        case 'CX_MANAGERS':
            return StepUserGroup.CX_MANAGERS;
        case 25:
        case 'CX_QA':
            return StepUserGroup.CX_QA;
        case 23:
        case 'DATA':
            return StepUserGroup.DATA;
        case 26:
        case 'DATA_MANAGER':
            return StepUserGroup.DATA_MANAGER;
        case 17:
        case 'DESIGN':
            return StepUserGroup.DESIGN;
        case 7:
        case 'ENGINEERING':
            return StepUserGroup.ENGINEERING;
        case 28:
        case 'ENGINEERING_MANAGERS':
            return StepUserGroup.ENGINEERING_MANAGERS;
        case 4:
        case 'FINANCE':
            return StepUserGroup.FINANCE;
        case 14:
        case 'FRAUD':
            return StepUserGroup.FRAUD;
        case 19:
        case 'GROWTH':
            return StepUserGroup.GROWTH;
        case 20:
        case 'GROWTH_MANAGERS':
            return StepUserGroup.GROWTH_MANAGERS;
        case 24:
        case 'KYC_REVIEW':
            return StepUserGroup.KYC_REVIEW;
        case 22:
        case 'LEGAL':
            return StepUserGroup.LEGAL;
        case 10:
        case 'PRODUCT':
            return StepUserGroup.PRODUCT;
        case 29:
        case 'PRODUCT_MANAGERS':
            return StepUserGroup.PRODUCT_MANAGERS;
        case 21:
        case 'RECRUITING':
            return StepUserGroup.RECRUITING;
        case 18:
        case 'RESEARCH':
            return StepUserGroup.RESEARCH;
        case 16:
        case 'RISK_MANAGERS':
            return StepUserGroup.RISK_MANAGERS;
        case 15:
        case 'TRUST_SAFETY':
            return StepUserGroup.TRUST_SAFETY;
        case 31:
        case 'UBIQUITY':
            return StepUserGroup.UBIQUITY;
        case 99:
        case 'SUPER_USERS':
            return StepUserGroup.SUPER_USERS;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return StepUserGroup.UNRECOGNIZED;
    }
}
exports.stepUserGroupFromJSON = stepUserGroupFromJSON;
function stepUserGroupToJSON(object) {
    switch (object) {
        case StepUserGroup.INVALID_STEP_USER_GROUP:
            return 'INVALID_STEP_USER_GROUP';
        case StepUserGroup.AML:
            return 'AML';
        case StepUserGroup.BATCH_FUNDING_ADMIN:
            return 'BATCH_FUNDING_ADMIN';
        case StepUserGroup.COMPLIANCE:
            return 'COMPLIANCE';
        case StepUserGroup.COMPLIANCE_MANAGERS:
            return 'COMPLIANCE_MANAGERS';
        case StepUserGroup.CX:
            return 'CX';
        case StepUserGroup.CX_MANAGERS:
            return 'CX_MANAGERS';
        case StepUserGroup.CX_QA:
            return 'CX_QA';
        case StepUserGroup.DATA:
            return 'DATA';
        case StepUserGroup.DATA_MANAGER:
            return 'DATA_MANAGER';
        case StepUserGroup.DESIGN:
            return 'DESIGN';
        case StepUserGroup.ENGINEERING:
            return 'ENGINEERING';
        case StepUserGroup.ENGINEERING_MANAGERS:
            return 'ENGINEERING_MANAGERS';
        case StepUserGroup.FINANCE:
            return 'FINANCE';
        case StepUserGroup.FRAUD:
            return 'FRAUD';
        case StepUserGroup.GROWTH:
            return 'GROWTH';
        case StepUserGroup.GROWTH_MANAGERS:
            return 'GROWTH_MANAGERS';
        case StepUserGroup.KYC_REVIEW:
            return 'KYC_REVIEW';
        case StepUserGroup.LEGAL:
            return 'LEGAL';
        case StepUserGroup.PRODUCT:
            return 'PRODUCT';
        case StepUserGroup.PRODUCT_MANAGERS:
            return 'PRODUCT_MANAGERS';
        case StepUserGroup.RECRUITING:
            return 'RECRUITING';
        case StepUserGroup.RESEARCH:
            return 'RESEARCH';
        case StepUserGroup.RISK_MANAGERS:
            return 'RISK_MANAGERS';
        case StepUserGroup.TRUST_SAFETY:
            return 'TRUST_SAFETY';
        case StepUserGroup.UBIQUITY:
            return 'UBIQUITY';
        case StepUserGroup.SUPER_USERS:
            return 'SUPER_USERS';
        case StepUserGroup.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.stepUserGroupToJSON = stepUserGroupToJSON;
//# sourceMappingURL=step-user-group.js.map